import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { ClientService } from '../../services/client/client.service';
import { first, map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ClientResolve implements Resolve<any> {

    constructor(private cs: ClientService) { }

    resolve(route: ActivatedRouteSnapshot) {
        return this.cs.allClients().pipe(map(clients => clients)).pipe(first());
    }

}
